import styled from 'styled-components';
import { IStyledStoreButton } from './index';

export const StyledStoreButton = styled.a<IStyledStoreButton>`
  position: relative;
  width: 100%;
  display: flex;
  ${({ mb }) => mb && `margin-bottom: ${mb}px;`};

  & img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;
